let app_serverUrl = ''
let app_gateway = ''
let app_priava = ''
let app_tokenUrl = ''
let app_billercode = 0
let app_testmode = false

if(process.env.APP_ENV === 'local') {
    app_serverUrl = ''
    app_gateway = 'https://apitest.fairfieldcity.nsw.gov.au'
    app_priava = 'https://apac-sandbox-app.priava.com'
    app_tokenUrl = 'https://apitest.fairfieldcity.nsw.gov.au'
    app_billercode = 1331479
    app_testmode = true
}


if(process.env.APP_ENV === 'development') {
    app_serverUrl = 'https://websiteappdev.fairfieldcity.nsw.gov.au'
    app_gateway = 'https://apitest.fairfieldcity.nsw.gov.au'
    app_priava = 'https://apac-sandbox-app.priava.com'
    app_tokenUrl = 'https://apitest.fairfieldcity.nsw.gov.au'
    app_billercode = 1331479
    app_testmode = true
}


if(process.env.APP_ENV === 'testing') {
    app_serverUrl = 'https://websitetest.fairfieldcity.nsw.gov.au'
    app_gateway = 'https://apitest.fairfieldcity.nsw.gov.au'
    app_priava = 'https://apac-sandbox-app.priava.com'
    app_tokenUrl = 'https://apitest.fairfieldcity.nsw.gov.au'
    app_billercode = 1331479
    app_testmode = true
}


if(process.env.APP_ENV === 'production') {
    app_serverUrl = 'https://app.fairfieldcity.nsw.gov.au'
    app_gateway = 'https://api.fairfieldcity.nsw.gov.au'
    app_priava = 'https://apac-app.priava.com'
    app_tokenUrl = 'https://api.fairfieldcity.nsw.gov.au'
    app_billercode = 1291392
    app_testmode = false
}

export const Envs = {
    serverUrl: app_serverUrl,
    gateway: app_gateway,
    priava: app_priava,
    tokenUrl: app_tokenUrl,
    billercode: app_billercode,
    testmode: app_testmode,
};


export const allVenuesAPI = '/api/rest/v2/common/catl/get';

export const confirmPaidBookingAPI =
  '/api/rest/v2/event/save?IgnoreWarnings=true';

export const searchBookingAPI =
//  '/api/rest/v2/venue/get/booking?IgnoreWarnings=true';
  '/api/public/priava/getbookings'; 
 
export const searchFacilityAPI =
  '/api/rest/v2/venue/add/booking?IgnoreWarnings=true';

export const createOpportunitiesAPI =
  '/api/rest/v2/opportunity/save?IgnoreWarnings=true';

export const addContactAPI = '/api/rest/v2/contact/save';

export const addOrUpdateOrg = '/api/rest/v2/organisation/save';

export const smartPricingAPI = '/api/rest/v2/priceSchedule/opp/vb/getMatching';

export const venuesAPI = '/api/rest/v2/venues';

export const tokenAPI = '/api/public/priava/rest/auth';

export const recordBooking = '/api/public/bookings/facilitybookings/';

export const bookingCheckpoint = '/api/public/checkpoint';

export const localToken =
  'Gcb5EBRdBaBL6tbfLUJ4QHNqybs4rAq2sWMH87tIRcQvuOszRApLgT2Rqe1jnax9';

export const fcctoken = '09867564..^%';

export const PaymentRD =
  'https://app.fairfieldcity.nsw.gov.au/payments/receipt.html';

export const surchargeRate = 0.0075;

export const searchResultLimit = 5;

export const weeklyDefinition = 5;
